import { cn } from "@/lib/utils";

const CATEGORY_DISPLAY = {
  General: { className: "bg-muted text-muted-foreground" },
  Environmental: {
    className:
      "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300",
  },
  Social: {
    className:
      "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
  },
  Governance: {
    className:
      "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  },
};

const CategoryBadge = ({ category }) => {
  const config = CATEGORY_DISPLAY[category];
  if (!config) {
    return <span className="text-xs text-muted-foreground">—</span>;
  }
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded px-2 py-0.5 font-medium text-xs",
        config.className,
      )}
    >
      {category}
    </span>
  );
};

export default CategoryBadge;
